import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faArrowLeft,
    faClock,
    faTag,
    faArrowRight,
    faHome,
} from '@fortawesome/free-solid-svg-icons'
import type { KbCategoryDetail } from '../types'
import { resolveIcon } from '../utils/iconMap'

interface CategoryViewProps {
    category: KbCategoryDetail
    onBack: () => void
    onSelectArticle: (slug: string) => void
}

const CategoryView = ({
    category,
    onBack,
    onSelectArticle,
}: CategoryViewProps) => {
    return (
        <section className="kb-category-view">
            <div className="kb-category-view__breadcrumb">
                <button onClick={onBack} className="kb-breadcrumb__link">
                    <FontAwesomeIcon icon={faHome} className="me-1" />
                    Knowledge Base
                </button>
                <span className="kb-breadcrumb__sep">/</span>
                <span className="kb-breadcrumb__current">
                    {category.title}
                </span>
            </div>

            <div className="kb-category-view__header">
                <button
                    onClick={onBack}
                    className="kb-category-view__back"
                    title="Back to Knowledge Base"
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                </button>
                <div
                    className="kb-category-view__icon"
                    style={{ background: category.gradient }}
                >
                    <FontAwesomeIcon icon={resolveIcon(category.icon)} />
                </div>
                <div>
                    <h1 className="kb-category-view__title">
                        {category.title}
                    </h1>
                    <p className="kb-category-view__desc">
                        {category.description}
                    </p>
                </div>
            </div>

            <div className="kb-category-view__articles">
                {category.articles.map((article, idx) => (
                    <button
                        key={article.id}
                        className="kb-article-card"
                        onClick={() => onSelectArticle(article.slug)}
                        style={
                            { '--article-index': idx } as React.CSSProperties
                        }
                    >
                        <div className="kb-article-card__content">
                            <h3 className="kb-article-card__title">
                                {article.title}
                            </h3>
                            <p className="kb-article-card__excerpt">
                                {article.excerpt}
                            </p>
                            <div className="kb-article-card__meta">
                                <span className="kb-article-card__time">
                                    <FontAwesomeIcon
                                        icon={faClock}
                                        className="me-1"
                                    />
                                    {article.reading_time} min read
                                </span>
                                <div className="kb-article-card__tags">
                                    {(Array.isArray(article.tags) ? article.tags : []).slice(0, 3).map((tag) => (
                                        <span
                                            key={tag}
                                            className="kb-article-card__tag"
                                        >
                                            <FontAwesomeIcon
                                                icon={faTag}
                                                className="me-1"
                                                size="xs"
                                            />
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="kb-article-card__arrow">
                            <FontAwesomeIcon icon={faArrowRight} />
                        </div>
                    </button>
                ))}
            </div>
        </section>
    )
}

export default CategoryView
